import { Box, Stack, Td, Th, Tr } from '@chakra-ui/react';
import { useFetchPurchaseOrderPageQuery } from 'api';
import { useAuth, usePagination } from 'core';
import Decimal from 'decimal.js';
import {
  AfeLink,
  AppTable,
  CommitmentVsBudgetBar,
  DateDisplay,
  InvoicedVsCommitmentBar,
  MultiBar,
  PurchaseOrderLink,
  UserLink,
} from 'features';
import { useMemo } from 'react';

export interface PurchaseOrderSearchPageProps {}

export const PurchaseOrderSearchPage = (
  props: PurchaseOrderSearchPageProps
) => {
  const auth = useAuth();
  const [page, setPagination] = usePagination();
  const { data: results } = useFetchPurchaseOrderPageQuery({
    ...page,
    clientId: auth?.user?.clientId ?? '0',
  });

  let body = [
    <Tr key={0}>
      <Td colSpan={6}>Searching...</Td>
    </Tr>,
  ];

  // const alteredItems = useMemo(() => {
  //   return results?.items.map((po) => {
  //     const calcApprovedBudget = new Decimal(po.totalBudgeted);
  //     const calcPendingBudget = new Decimal(po.pendingBudgeted);
  //     const calcTotalBudget = calcApprovedBudget.add(calcPendingBudget);

  //     const calcApprovedCommitment = new Decimal(po.total);
  //     const calcPendingCommitment = new Decimal(po.pending);
  //     const calcTotalCommitment = calcApprovedBudget.add(calcPendingBudget);

  //     const calcApprovedInvoice = new Decimal(po.totalInvoice);
  //     const calcPendingInvoice =new Decimal(po.pendingInvoice);

  //     // Remainings
  //     const calcRawRemaining
  //     return {
  //       ...po,
  //       x,
  //     };
  //   });
  // }, [results?.items]);

  if (results?.items?.length) {
    body = results?.items?.map((po, i) => (
      <Tr key={i}>
        <Td>
          <PurchaseOrderLink po={results?.items[i]} />
        </Td>
        <Td>
          <AfeLink afe={po.afe} />
        </Td>
        <Td>
          <UserLink u={po.assigneeUser ?? undefined} />
        </Td>
        <Td>
          <MultiBar
            max={[po.totalBudgeted, po.totalContingency]}
            values={[po.total]}
          />
        </Td>
        <Td>
          <MultiBar max={[po.total]} values={[po.totalInvoice]} />
        </Td>
        {/* <Td>
          <CommitmentVsBudgetBar
            commitment={po?.total}
            pending={po?.pending}
            budget={po?.totalBudgeted}
            contingency={po?.totalContingency}
          />
        </Td> */}
        {/* <Td>
          <InvoicedVsCommitmentBar
            invoice={po?.totalInvoice}
            pendingInvoice={po?.pendingInvoice}
            commitment={po?.total}
          />
        </Td> */}
        <Td>
          <DateDisplay value={po?.commitmentDate} />
        </Td>
      </Tr>
    ));
  }

  return (
    <Box>
      <Stack>
        <AppTable
          title="Search Purchase Orders"
          body={<>{body}</>}
          header={
            <Tr>
              <Th>Purchase Order</Th>
              <Th>AFE</Th>
              <Th>Assigned</Th>
              <Th>Budget</Th>
              <Th>Invoiced</Th>
              <Th>Committed Date</Th>
            </Tr>
          }
          pagination={{
            ...page,
            itemCount: results ? Number(results.itemCount) : 0,
            pageCount: results ? Number(results.pageCount) : 1,
          }}
          onPaginationChange={setPagination}
        />
      </Stack>
    </Box>
  );
};
